import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import classNames from 'classnames';

import './container.scss';

type ContainerProps = {
    className?: string;
    children: React.ReactNode;
    dataSection?: string;
};

const Container: React.FC<ContainerProps> = ({ className, children, dataSection }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div
            className={classNames({
                'container-wrapper': true,
                'container-wrapper--m': api.getDevice() === 'mobile',
                [String(className)]: Boolean(className)
            })}
            data-section={dataSection}
        >
            {children}
        </div>
    );
};

export default Container;
